import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiDefinition = z.object({
  kpiDefinitionId: z.string(),
  kpiName: z.string(),
  kpiDescription: z.string(),
  isCustomKpi: z.boolean(),
  isAssetLevel: z.boolean(),
  frequency: z.number(),
  isEnabled: z.boolean().nullable(),
  assetId: z.string().nullable().optional(),
  assetTypeId: z.string().nullable().optional()
})

const ZTiqKpiDefinitionDTO = z.object({
  totalCount: z.number(),
  content: z.array(ZKpiDefinition)
})

const ZTiqApiResponse = z.object({
  http_status: z.number(),
  data: ZTiqKpiDefinitionDTO.nullable(),
  error: z.boolean()
})

export type TiqKpiDefinitionDTO = z.infer<typeof ZTiqKpiDefinitionDTO>

export type KpiDefinitionData = z.infer<typeof ZKpiDefinition>

export async function getKpiBySearchValue (
  searchValue: string,
  filterValue: boolean,
  pageNumber: number,
  pageSize: number,
  sortBy: string,
  sortOrder: string,
  onSuccess: (KpiList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/kpirest/api/v1/udp/tiq/kpi/allKpiSummary'

  interceptedAxios
    .get(url, {
      params: {
        searchValue,
        filterValue,
        pageNumber,
        pageSize,
        sortOrder,
        sortBy
      },
      timeout: 15000
    })
    .then((response: any) => {
      const parseResponse = ZTiqApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
            parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
